<p>You don't have appropriate permissions to view this page.  You need @if(groupOperator === "or"){one}@else{all} of the following permissions</p>

<ul class="list-disc pl-5">
    @for (role of roles; track $index) {
        <li>{{role}}</li>
    }
</ul>

<div class="flex flex-col gap-2">
    <a [href]="homeUrl()" >Go to Home</a>
    <a [href]="signOutUrl">Sign Out</a>
</div>

